var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('img',{staticClass:"brand-image header-height",attrs:{"src":"/images/logo_lifeed.png","alt":"lifeed"},on:{"click":_vm.redirectToHome}})])
}
var staticRenderFns = []

export { render, staticRenderFns }